/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RepostNotificationAction } from './RepostNotificationAction';
import {
    RepostNotificationActionFromJSON,
    RepostNotificationActionFromJSONTyped,
    RepostNotificationActionToJSON,
} from './RepostNotificationAction';

/**
 * 
 * @export
 * @interface RepostNotification
 */
export interface RepostNotification {
    /**
     * 
     * @type {string}
     * @memberof RepostNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RepostNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof RepostNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepostNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<RepostNotificationAction>}
     * @memberof RepostNotification
     */
    actions: Array<RepostNotificationAction>;
}

/**
 * Check if a given object implements the RepostNotification interface.
 */
export function instanceOfRepostNotification(value: object): value is RepostNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function RepostNotificationFromJSON(json: any): RepostNotification {
    return RepostNotificationFromJSONTyped(json, false);
}

export function RepostNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(RepostNotificationActionFromJSON)),
    };
}

export function RepostNotificationToJSON(value?: RepostNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(RepostNotificationActionToJSON)),
    };
}

